import React from "react";
import { useTranslation } from "react-i18next";
import Moment from "react-moment";
const DateTime = (props:any) => {
  const { i18n }:any = useTranslation();
  const { inputDate, returnFormat } = props;
  return <Moment local={i18n.language} date={inputDate} format={returnFormat ? returnFormat : ""} />;
};

export default DateTime;
